import React from 'react';
import { Routes, Route } from 'react-router-dom';
import GameSelector from './GameSelector';
import GamesPage from './pages/GamesPage';
import ProfilePage from './pages/ProfilePage';
import PremiumPage from './pages/PremiumPage';
import DongengPage from './pages/DongengPage';
import FavoritesPage from './pages/FavoritesPage';
import PaymentHistoryPage from './pages/PaymentHistoryPage';
import DonatePage from './pages/DonatePage';
import TumbuhKembangPage from './pages/TumbuhKembangPage';
import StimulasiPage from './pages/StimulasiPage';
import GrowthPage from './pages/GrowthPage';
import MPASIPage from './pages/MPASIPage';
import ImmunizationPage from './pages/ImmunizationPage';
import PremiumGuard from './components/PremiumGuard';
import BannedPage from './pages/BannedPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import FAQPage from './pages/FAQPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import { UnsubscribePage } from './components/EmailPreferences';
import PuzzleGame from './games/PuzzleGame/Game';
import MemoryGame from './games/MemoryGame/Game';
import ColorGame from './games/ColorGame/Game';
import LetterMatchGame from './games/LetterMatchGame/Game';
import AnimalGame from './games/AnimalGame/Game';
import ParrotGame from './games/ParrotGame/Game';
import ShadowGame from './games/ShadowGame/Game';
import MazeGame from './games/MazeGame/Game';
import ShapeMatchGame from './games/ShapeMatchGame/Game';
import OddOneOutGame from './games/OddOneOutGame/Game';
import ColoringGame from './games/ColoringGame/Game';
import GameTemplate from './games';

// Layout imports
import EndUserLayout from './layouts/EndUserLayout';

// Admin imports
import {
  AdminLayout,
  DashboardPage as AdminDashboard,
  UsersPage as AdminUsers,
  PaymentsPage as AdminPayments,
  GamesPage as AdminGames,
  DongengPage as AdminDongeng,
  TumbuhKembangPage as AdminTumbuhKembang,
  VouchersPage as AdminVouchers,
  EmailPage as AdminEmail,
  SettingsPage as AdminSettings,
} from './admin';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public pages - outside of layouts */}
      <Route path="/banned" element={<BannedPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/kebijakan-privasi" element={<PrivacyPolicyPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/refund-policy" element={<RefundPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/syarat-ketentuan" element={<TermsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/kontak" element={<ContactPage />} />
      <Route path="/unsubscribe" element={<UnsubscribePage />} />

      {/* End User Routes - wrapped with onboarding modal */}
      <Route element={<EndUserLayout />}>
        <Route path="/" element={<GameSelector />} />
        <Route path="/games"   element={<GamesPage />} />
        <Route path="/profile"   element={<ProfilePage />} />
        <Route path="/premium"   element={<PremiumPage />} />
        <Route path="/dongeng"   element={<DongengPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/payments"  element={<PaymentHistoryPage />} />
        <Route path="/donate"    element={<DonatePage />} />
        <Route path="/tumbuh-kembang" element={<TumbuhKembangPage />} />
        <Route path="/tumbuh-kembang/stimulasi" element={
          <PremiumGuard featureName="Agenda Stimulasi">
            <StimulasiPage />
          </PremiumGuard>
        } />
        <Route path="/tumbuh-kembang/growth" element={<GrowthPage />} />
        <Route path="/tumbuh-kembang/mpasi" element={<MPASIPage />} />
        <Route path="/tumbuh-kembang/imunisasi" element={<ImmunizationPage />} />
        <Route path="/puzzle"       element={<GameTemplate slug="puzzle"        game={PuzzleGame}     title="Puzzle Game"         hideHeader />} />
        <Route path="/memory"       element={<GameTemplate slug="memory"        game={MemoryGame}     title="Memory Game"         hideHeader />} />
        <Route path="/memory/:type" element={<GameTemplate slug="memory-alphabet" game={MemoryGame}   title="Memory Game"         hideHeader />} />
        <Route path="/color"        element={<GameTemplate slug="color"         game={ColorGame}      title="Color Game"          hideHeader />} />
        <Route path="/letter-match" element={<GameTemplate slug="letter-match"  game={LetterMatchGame} title="Letter Match Game"  hideHeader />} />
        <Route path="/animal"       element={<GameTemplate slug="animal"        game={AnimalGame}     title="Mengenal Hewan"      hideHeader />} />
        <Route path="/parrot"       element={<GameTemplate slug="parrot"        game={ParrotGame}     title="Kakaktua Pintar"     hideHeader />} />
        <Route path="/shadow"       element={<GameTemplate slug="shadow"        game={ShadowGame}     title="Pasangkan Bayangan"  hideHeader />} />
        <Route path="/maze"         element={<GameTemplate slug="maze"          game={MazeGame}       title="Labirin Hewan" hideHeader />} />
        <Route path="/shape-match"  element={<GameTemplate slug="shape-match"   game={ShapeMatchGame} title="Hubungkan Bentuk" hideHeader />} />
        <Route path="/odd-one-out" element={<GameTemplate slug="odd-one-out"  game={OddOneOutGame}  title="Temukan yang Berbeda" hideHeader />} />
        <Route path="/coloring"    element={<GameTemplate slug="coloring"     game={ColoringGame}   title="Mewarnai Digital" hideHeader />} />
      </Route>

      {/* Admin Routes - no onboarding modal */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="games" element={<AdminGames />} />
        <Route path="dongeng" element={<AdminDongeng />} />
        <Route path="tumbuh-kembang" element={<AdminTumbuhKembang />} />
        <Route path="email" element={<AdminEmail />} />
        <Route path="vouchers" element={<AdminVouchers />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
